import React from "react";
import "./Pay.scss";
import i18n from "i18n";
import { IonCard, IonCardContent, IonButton, IonLabel, IonRow, isPlatform } from "@ionic/react";
import { RATE_DETAILS_NOTE } from "../../../utils/constants";
import RateDetails from "./RateDetails/RateDetails";
import {ComponentProps} from "./Pay.types";
import { IONICWrapper } from "../../../utils/common";

export default({ shipmentCostItems, costCurrency, totalCostAmount , onOkClick,loadDetails }: ComponentProps) => {
  const isMobile = isPlatform("mobile") || isPlatform("mobileweb");

  const rateDetailsNote = IONICWrapper.details.keys && IONICWrapper.details.keys.configuration && IONICWrapper.details.keys.configuration.rateDetailsNote || RATE_DETAILS_NOTE;
  return (
    <div className={`pay-component${isMobile ? '' : ' pay-component-margin-web'}`}>
    { shipmentCostItems?.length ? (
        <>
          <div className="card-content" data-testid={"rate-details"}>
            <RateDetails
              shipmentCostItems={shipmentCostItems}
              costCurrency={costCurrency}
              totalCostAmount={totalCostAmount}
            />
          </div>
          <div className="instructions">
            <IonLabel className={"rate-details-instructions"} data-testid={"rate-details-instructions"}>{rateDetailsNote}</IonLabel>
            {isMobile &&
              <>
                <br />
                <IonRow className={"ok-button-row"}>
                  <IonButton className={"ok-button"} data-testid={"ok-button"} onClick={() => onOkClick()}>{i18n.t("Ok_TEXT")}</IonButton>
                </IonRow>
              </>
            }
          </div>
        </>
      ) : (
          <IonCard class="no-rate-details-found" data-testid={"no-rate-details-found"}>
            <IonCardContent>
              <div>{i18n.t("No rate details found")}</div>
            </IonCardContent>
          </IonCard>
        )}
    </div>
  );
};
